import { render } from "./Basic.vue?vue&type=template&id=739a989c"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"
script.render = render

export default script